// import React, {useState, useEffect} from 'react';
// import {List, ListItem, ListItemText, Divider} from '@mui/material';
// import Collapse from '@mui/material/Collapse';
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import {Link} from 'react-router-dom';
// import {EvaluarPermiso} from '../../Genericos/Generales';

// const Clientes = props => {

//   const classes = props.classes;
//   const sesionUsuario = props.sesionUsuario;

//   const [gestionClientes, setGestionClientes] = useState(false);
//   const [clientes, setClientes] = useState(false);
//   const [posiblesClientes, setPosiblesClientes] = useState(false);
//   const [contactos, setContactos] = useState(false);
//   const [buzonSugerencias, setBuzonSugerencias] = useState(false);
//   const [panelSugerencias, setPanelSugerencias] = useState(false);

//   useEffect (() => {
//     VerificarPermisos (
//       sesionUsuario.usuario.pantallasUsuario.listaPantallasRol
//     );
//   }, [sesionUsuario]);

//   const VerificarPermisos = arrPermisos => {
//     setGestionClientes(EvaluarPermiso(arrPermisos, '/gestionClientes'));
//     setClientes(EvaluarPermiso(arrPermisos, '/clientesPrincipal'));
//       setPosiblesClientes(
//         EvaluarPermiso(arrPermisos, '/posiblesClientesPrincipal')
//       );
//       setContactos(EvaluarPermiso(arrPermisos, '/contactosPrincipal'));
//       setBuzonSugerencias(EvaluarPermiso(arrPermisos, '/buzonSugerencias'));
//       setPanelSugerencias(EvaluarPermiso(arrPermisos, '/panelSugerencias'));
//   };

//   const [openGestionClientes, setOpenGestionClientes] = useState(false);
//   const handleOpenGestionClientes = () => {
//     setOpenGestionClientes(!openGestionClientes);
//   };

//   return(
//       <React.Fragment>
//           {gestionClientes ? (
//         <List>
//           <ListItem onClick={handleOpenGestionClientes}>
//             <i notranslate="true" className="material-icons">
//               people
//             </i>
//             <ListItemText
//               classes={{ primary: classes.listItemText }}
//               primary="Gestión de Clientes"
//             />
//             {openGestionClientes ? <ExpandLess /> : <ExpandMore />}
//           </ListItem>
//           <Collapse in={openGestionClientes} timeout="auto" unmountOnExit>
//             <List component="div" disablePadding>
//               <div>
//                 {clientes ? (
//                   <ListItem
//                     component={Link}
//                     button
//                     to="/clientesPrincipal"
//                     className={classes.listItemText}
//                   >
//                     <i notranslate="true" className="material-icons">
//                       how_to_reg
//                     </i>
//                     <ListItemText primary="Clientes" />
//                   </ListItem>
//                 ) : null}
//                 {posiblesClientes ? (
//                   <ListItem
//                     component={Link}
//                     button
//                     to="/posiblesClientesPrincipal"
//                     className={classes.listItemText}
//                   >
//                     <i notranslate="true" className="material-icons">
//                       person_add_alt_1
//                     </i>
//                     <ListItemText primary="Posibles Clientes" />
//                   </ListItem>
//                 ) : null}
//               </div>
//               {contactos ? (
//                 <ListItem
//                   component={Link}
//                   button
//                   to="/contactosPrincipal"
//                   className={classes.listItemText}
//                 >
//                   <i notranslate="true" className="material-icons">
//                     contacts
//                   </i>
//                   <ListItemText primary="Contactos" />
//                 </ListItem>
//               ) : null}
//               {buzonSugerencias ? (
//                 <ListItem
//                   component={Link}
//                   button
//                   to="/buzonSugerencias"
//                   className={classes.listItemText}
//                 >
//                   <i notranslate="true" className="material-icons">
//                     archive
//                   </i>
//                   <ListItemText primary="Reporte sobre Cliente" />
//                 </ListItem>
//               ) : null}
//               {panelSugerencias ? (
//                 <ListItem
//                   component={Link}
//                   button
//                   to="/panelSugerencias"
//                   className={classes.listItemText}
//                 >
//                   <i notranslate="true" className="material-icons">
//                     theater_comedy
//                   </i>
//                   <ListItemText primary="Consultar Reportes Sobre Clientes" />
//                 </ListItem>
//               ) : null}
//             </List>
//           </Collapse>
//         </List>
//       ) : null}
//       {gestionClientes ? <Divider /> : null}
//       </React.Fragment>
//   )
// }

// export default Clientes
import React, { useState, useEffect } from 'react';
import { List, ListItem, ListItemText, ListItemIcon, Collapse } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ContactsIcon from '@mui/icons-material/Contacts';
import ArchiveIcon from '@mui/icons-material/Archive';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';
import { EvaluarPermiso } from '../../Genericos/Generales';
import { menuItemStyles } from '../../Tools/MenuItemStyles';

const Clientes = ({ sesionUsuario }) => {
  const [gestionClientes, setGestionClientes] = useState(false);
  const [clientes, setClientes] = useState(false);
  const [posiblesClientes, setPosiblesClientes] = useState(false);
  const [contactos, setContactos] = useState(false);
  const [buzonSugerencias, setBuzonSugerencias] = useState(false);
  const [panelSugerencias, setPanelSugerencias] = useState(false);
  const [openGestionClientes, setOpenGestionClientes] = useState(false);

  useEffect(() => {
    const permisos = sesionUsuario.usuario.pantallasUsuario.listaPantallasRol;
    setGestionClientes(EvaluarPermiso(permisos, '/gestionClientes'));
    setClientes(EvaluarPermiso(permisos, '/clientesPrincipal'));
    setPosiblesClientes(EvaluarPermiso(permisos, '/posiblesClientesPrincipal'));
    setContactos(EvaluarPermiso(permisos, '/contactosPrincipal'));
    setBuzonSugerencias(EvaluarPermiso(permisos, '/buzonSugerencias'));
    setPanelSugerencias(EvaluarPermiso(permisos, '/panelSugerencias'));
  }, [sesionUsuario]);

  const handleOpenGestionClientes = () => {
    setOpenGestionClientes(!openGestionClientes);
  };

  return (
    <>
      {gestionClientes && (
        <>
          <ListItem
            button
            onClick={handleOpenGestionClientes}
            sx={menuItemStyles.expandableHeader}
          >
            <ListItemIcon sx={menuItemStyles.menuIcon}>
              <PeopleIcon />
            </ListItemIcon>
            <ListItemText
              primary="Gestión de Clientes"
              sx={menuItemStyles.menuText}
            />
            {openGestionClientes ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={openGestionClientes} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {clientes && (
                <ListItem
                  button
                  component={Link}
                  to="/clientesPrincipal"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <HowToRegIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Clientes"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {posiblesClientes && (
                <ListItem
                  button
                  component={Link}
                  to="/posiblesClientesPrincipal"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <PersonAddIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Posibles Clientes"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {contactos && (
                <ListItem
                  button
                  component={Link}
                  to="/contactosPrincipal"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <ContactsIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Contactos"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {buzonSugerencias && (
                <ListItem
                  button
                  component={Link}
                  to="/buzonSugerencias"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <ArchiveIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Sugerencia de Cliente"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {panelSugerencias && (
                <ListItem
                  button
                  component={Link}
                  to="/panelSugerencias"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <TheaterComedyIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Consultar Sugerencias"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}
            </List>
          </Collapse>
        </>
      )}
    </>
  );
};

export default Clientes;
